export default __webpack_public_path__ + "static/media/Crt4.7b63d9df.png";